<template>
    <canvas id="canvas" ref="canvas"></canvas>
</template>


<!-- 
EXMAPLE - Using box-shadow
https://codepen.io/apexskier/pen/BzoYJg 
-->

<script>
import Size from '@/plugins/WindowSize'

export default {

    data: function() {
        return {
            canvasWidth: 0,
            canvasHeight: 0,
            hue: 0,
            scale: 1,
            
            isMouseDown: false,
            updateCanvas: false,
            currentPoint: {},
            lastPoint: {},
            
            
            // scale
            pulseSpeed: 0,
            requestId: undefined,
        }
    },
    
    created() {
        Size.addListener(this.onResize)
    },
    
    destroyed() {
        Size.removeListener(this.onResize)
    },
    
    mounted() {
        // implement code pen
        // https://codepen.io/robin_isaksson/pen/NWWvbyQ?editors=0010
        this.ctx = this.$refs.canvas.getContext('2d')
        
        this.canvasWidth = Size.width
        this.canvasHeight = document.body.scrollHeight
        
        this.$refs.canvas.width = this.canvasWidth
        this.$refs.canvas.height = this.canvasHeight
        
        this.ctx.lineWidth = 0;
        // this.ctx.fillStyle = "blue";
        // this.ctx.fillRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
        
        document.body.addEventListener('mousedown', this.onMouseDown)
        document.body.addEventListener('mouseup', this.onMouseUp)
        
        
        document.body.addEventListener('keypress', this.clearit)
        
        // this.ctx.fillStyle = 'rgba(255, 0, 255, 0.01)';
        // this.ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);
        
        
    },

    methods: {
        
        startAnimation() {
            // Start canvas drawing
            if (!this.requestId) {
                this.requestId = window.requestAnimationFrame(this.loop);
            }
        },
        
        stopAnimation() {
            if (this.requestId) {
                window.cancelAnimationFrame(this.requestId)
                this.requestId = undefined
            }
        },
        
        onMouseDown(event) {
            // this.currentPoint = { x: event.clientX, y: event.clientY + window.pageYOffset };
            // this.lastPoint = { x: event.clientX, y: event.clientY + window.pageYOffset };
            this.currentPoint = { x: event.clientX, y: event.clientY };
            this.lastPoint = { x: event.clientX, y: event.clientY };
            this.mouseDownInterval = window.setTimeout(this.mouseDown, 50);
        },
        
        mouseDown() {
            
            document.body.addEventListener('mousemove', this.onMouseMove)
            this.isMouseDown = true;
            this.updateCanvas = true;
            
            this.startAnimation()
        },

        onMouseUp() {
            // Reset timer
            window.clearTimeout(this.mouseDownInterval)
            
            
            this.isMouseDown = false;
            this.updateCanvas = false
            
            this.stopAnimation()
            
            document.body.removeEventListener('mousemove', this.onMouseMove)
            
            // this.lastPoint = { x: event.clientX, y: event.clientY + window.pageYOffset };
            // this.currentPoint = { x: event.clientX, y: event.clientY + window.pageYOffset };
            this.lastPoint = { x: event.clientX, y: event.clientY };
            this.currentPoint = { x: event.clientX, y: event.clientY };
            
            this.ctx.clearRect(0,0, this.canvasWidth, this.canvasHeight);
            
            // TODO - Fade out ctx by copying back and forth from second canvas (offscreenCanvas)
            // https://stackoverflow.com/questions/16776665/canvas-clearrect-with-alpha
            // https://stackoverflow.com/questions/43369748/how-to-render-offscreen-canvas-properly
            
            
            // this.mouseDownInterval = window.setTimeout(this.releaseMouse, 1000);
            // var obj = {
            //     fillOpacity: 1
            // }
            // TweenLite.to(obj, 1, {fillOpacity: 0, onUpdate: this.onUpdateTween, onUpdateParams:[this.ctx, this.$refs.canvas, "{self}"] });
        },
        
        // onUpdateTween(ctx, canvas, tween) {
        // 
        //     // TODO - https://stackoverflow.com/questions/16776665/canvas-clearrect-with-alpha
        //     ctx.globalAlpha = tween.target.fillOpacity
        // 
        //     //call its drawImage() function passing it the source canvas directly
        //     ctx.clearRect(0,0, this.canvasWidth, this.canvasHeight);
        // 
        //     ctx.drawImage(canvas, 0, 0);
        // },

        // releaseMouse() {
        //     console.log('release mouse - stop canvas drawing');
        //     this.updateCanvas = false
        // 
        //     this.stopAnimation()
        // },
        
        
        

        onMouseMove(event) {
            if (this.updateCanvas === false) return;
            
            // this.currentPoint = { x: event.clientX, y: event.clientY + window.pageYOffset };
            this.currentPoint = { x: event.clientX, y: event.clientY };
        },
        
        loop() {
            // console.log('loop');
            this.requestId = undefined
            
            // // Draw over the whole canvas to create the trail effect
            // // https://codepen.io/Tyriar/details/BfizE
            // this.ctx.fillStyle = 'rgba(255, 255, 255, 0.01)';
            // this.ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight); //ctx.fillRect(0, 0, el.width, el.height);
            
            if (this.isMouseDown === true) {
            
                
                var dist = this.distanceBetween(this.lastPoint, this.currentPoint);
                var angle = this.angleBetween(this.lastPoint, this.currentPoint);
                
                // Scale/Pulse
                // https://stackoverflow.com/questions/50014020/pulse-animation-in-canvas
                
                // this.pulseSpeed += Math.PI / 80;
                // var scale = 0.5 + Math.abs(Math.cos(this.pulseSpeed)); // number between 0.5 - 1.5 
                
                
                // Change color: 
                // https://editor.p5js.org/kellylougheed/sketches/ryPlD16wX
                this.hue = (this.hue > 360) ? 0 : this.hue+1

                var brushSize = window.innerWidth*0.08;
                // var brushSize = Math.max(80, Math.min(200, (5*dist))); // TODO - Make brushScaling depend on dist - Dist increases when moving mouse fast

                for (var i = 0; i < dist; i+=3) {
                    
                    let x = this.lastPoint.x + (Math.sin(angle) * i)
                    let y = this.lastPoint.y + (Math.cos(angle) * i)
                    
                    
                    // https://codepen.io/robin_isaksson/pen/yLLzvWY
                    var gradient = this.ctx.createRadialGradient(x, y, 0, x, y, brushSize/2); // x1, y1, r1, x1, y2, r2
                    // gradient.addColorStop(0, 'rgba(255, 0, 0, 0.1)');
                    // gradient.addColorStop(1, 'rgba(255, 0, 0, 0)');
                    gradient.addColorStop(0, 'hsla(' + this.hue + ', 65%, 50%, 0.1)');
                    gradient.addColorStop(1, 'hsla(' + this.hue + ', 65%, 50%, 0)');
                    
                    // Set the fill style and draw a rectangle
                    this.ctx.fillStyle = gradient;
                    this.ctx.fillRect(x-(brushSize/2), y-(brushSize/2), brushSize, brushSize);
                }
                
                this.lastPoint = this.currentPoint;
            }
            
            this.startAnimation()
        },

        clearit(event) {
            if(event.key === "1") {
                this.ctx.clearRect(0,0, this.canvasWidth, this.canvasHeight);
            }
        },

        onResize() {
            // console.log('onResize scrollHeight: ', Size);
            this.canvasWidth = Size.width
            this.canvasHeight = Size.height //document.body.scrollHeight

            this.$refs.canvas.width = this.canvasWidth
            this.$refs.canvas.height = this.canvasHeight
            
            // this.ctx.fillStyle = "blue";
            // this.ctx.fillRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
        },
        
        distanceBetween(point1, point2) {
            return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
        },
        
        angleBetween(point1, point2) {
            return Math.atan2( point2.x - point1.x, point2.y - point1.y );
        },
        
        normalizeValue(val, min, max) {
            return (val - min) / (max - min)
            // return Math.max(0, Math.min(1, (val - min) / (max - min)))
        },
        
        clampValue(value, min, max) {
            return Math.min(Math.max(value, min), max);
        },
    }
}
</script>

<style lang="scss" scoped>

@import '../scss/variables';

#canvas {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    pointer-events: none;
}

</style>
